import { useLocation, Navigate, Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "../../hooks/useAuth";

const RequiredAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  const isAllowed =
    auth?.roleId &&
    Array.isArray(allowedRoles) &&
    allowedRoles.includes(auth.roleId);

  const isAuthenticated = auth?.user;

  if (isAllowed && auth?.mfaRequired === true && auth?.mfaVerified !== true) {
    console.log("🔐 MFA Required but not verified - Blocking access to:", location.pathname);
    if (location.pathname !== "/mfa-setup") {
      return <Navigate to="/mfa-setup" state={{ from: location }} replace />;
    }
  }

  if (isAllowed) {
    if (!auth?.mfaRequired || auth?.mfaVerified) {
      return <Outlet />;
    }
    return <Navigate to="/mfa-setup" state={{ from: location }} replace />;
  }

  if (isAuthenticated) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Navigate to="/signIn" state={{ from: location }} replace />;
};

RequiredAuth.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default RequiredAuth;
